var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 510.4,
    height: 510.388,
    viewBox: "0 0 510.4 510.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medium-white",
    transform: "translate(-0.8 -0.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M511.2,256C511.2,115.155,396.851.806,256.006.806h-.012C115.149.806.8,115.155.8,256S115.149,511.194,255.994,511.194h.012C396.851,511.194,511.2,396.845,511.2,256Zm-229.576,0c0,62.731-50.508,113.584-112.81,113.584S56,318.721,56,256s50.508-113.588,112.814-113.588S281.624,193.271,281.624,256Zm123.757,0c0,59.048-25.255,106.934-56.407,106.934S292.567,315.05,292.567,256s25.25-106.935,56.4-106.935S405.377,196.939,405.377,256ZM456,256c0,52.892-8.881,95.8-19.838,95.8s-19.835-42.892-19.835-95.8,8.88-95.8,19.835-95.8S456,203.094,456,256Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumWhite);
export default __webpack_public_path__ + "static/media/medium-white.7a7305bff8b644b5bfa87f781c0c8ee1.svg";
export { ForwardRef as ReactComponent };